export type SalePaymentStatus = 'paid' | 'partial' | 'fiado' | 'cancelled' | 'pending';

/** Deriva payment_status desde pagos confirmados no-customer + allocations activas. */
export function deriveSalePaymentStatus(
  total: number,
  nonCustomerPaid: number,
  customerAllocationPaid: number,
  saleStatus: 'active' | 'voided' = 'active'
): Exclude<SalePaymentStatus, 'pending'> {
  const safeTotal = Number.isFinite(total) ? total : 0;
  if (saleStatus === 'voided') return 'cancelled';

  const nonCustomer = Math.max(0, nonCustomerPaid);
  const customerPaid = Math.max(0, customerAllocationPaid);
  const paid = nonCustomer + customerPaid;

  if (paid >= safeTotal) return 'paid';
  if (paid > 0) return 'partial';
  return 'fiado';
}

/** Monto customer pendiente de cobro (excluye efectivo/tarjeta al checkout). */
export function deriveCustomerPendingAmount(
  total: number,
  nonCustomerPaid: number,
  customerAllocationPaid: number
): number {
  const safeTotal = Number.isFinite(total) ? total : 0;
  const nonCustomer = Math.max(0, nonCustomerPaid);
  const customerPaid = Math.max(0, customerAllocationPaid);
  return Math.max(0, safeTotal - nonCustomer - customerPaid);
}
